import { IconBase } from './IconBase'

type IconLineProps = React.ComponentProps<'svg'>

export const IconLine = (props: IconLineProps) => {
  return (
    <IconBase width="1em" viewBox="0 0 24 24" {...props}>
      <path
        d="M12.56 22.26c-1.057.581-1.012-.274-.967-.538l.15-.893c.035-.267.072-.68-.033-.944-.118-.29-.583-.44-.925-.514-5.045-.663-8.78-4.171-8.78-8.358 0-4.671 4.71-8.472 10.498-8.472C18.29 2.541 23 6.341 23 11.012c0 5.247-5.564 8.567-10.44 11.248Zm-3.376-9.338a.51.51 0 0 0-.511-.507H7.245V9.076a.51.51 0 0 0-.512-.507.51.51 0 0 0-.511.507v3.847c0 .28.23.508.511.508h1.94a.51.51 0 0 0 .511-.508Zm1.494-3.846a.51.51 0 0 0-.511-.507.51.51 0 0 0-.512.507v3.847c0 .28.23.508.512.508a.51.51 0 0 0 .511-.508V9.076Zm4.67 0a.51.51 0 0 0-.511-.507.51.51 0 0 0-.513.507v2.38l-1.989-2.684a.516.516 0 0 0-.571-.177.508.508 0 0 0-.35.482v3.847c0 .28.23.508.512.508a.51.51 0 0 0 .513-.508v-2.38l1.988 2.684a.515.515 0 0 0 .571.177.505.505 0 0 0 .35-.481V9.076Zm3.14 1.416h-1.429v-.908h1.428A.51.51 0 0 0 19 9.076a.51.51 0 0 0-.513-.507h-1.94a.51.51 0 0 0-.51.507v3.846c0 .28.23.508.51.508h1.94a.511.511 0 0 0 .513-.508.51.51 0 0 0-.513-.508H17.06v-.908h1.428a.51.51 0 0 0 .513-.508.51.51 0 0 0-.513-.507v.001Z"
        fill="#fff"
      />
    </IconBase>
  )
}
